/* Ten Antennas — cart page behaviour.

   • THE NOTE MOVES TO THE LEFT COLUMN. In the mockup it sits under the item
     list; in Dawn's markup it is inside the FOOTER section, so laying the page
     out in two columns carries it into the right rail. CSS cannot move a node
     between sections — only script can. It is moved, not cloned: the textarea
     posts with form="cart" and a copy would submit nothing.

     IT MUST GO AFTER THE TABLE, NOT INSIDE IT. The item list is a real
     <table>, and a custom element appended inside one is not valid there — the
     parser hoists it back out, which left a stray frame around the whole list.
     The note is inserted as the table's next sibling instead.

   • THE LABEL IS RENAMED. "Order special instructions" is Shopify's phrase for
     a warehouse field. "Order notes" is what a person writing about engraving
     or gift wrapping thinks they are doing.
*/
(function () {
  if (window.__taCartPage) return;
  window.__taCartPage = true;

  var NOTE_LABEL = 'Order notes';
  var NOTE_PLACEHOLDER = 'Engraving, gift wrapping, delivery timing — anything we should know.';

  function onCartPage() {
    return /^\/cart(\/|$|\?)/.test(window.location.pathname);
  }

  function svgEl(viewBox, paths, cls) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    if (cls) svg.setAttribute('class', cls);
    paths.forEach(function (d) {
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', d);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.2');
      svg.appendChild(p);
    });
    return svg;
  }

  function buildHeader() {
    var cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.querySelector('.ta-cart-caret')) return;

    cartLink.appendChild(svgEl('0 0 12 8', ['M1 6.5 6 1.5l5 5'], 'ta-cart-caret'));

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ta-cart-close';
    close.setAttribute('aria-label', 'Close cart');
    close.appendChild(svgEl('0 0 14 14', ['M1 1l12 12', 'M13 1L1 13']));
    close.addEventListener('click', function () {
      if (window.history.length > 1 && document.referrer) {
        window.history.back();
      } else {
        window.location.href = '/collections/all';
      }
    });
    cartLink.insertAdjacentElement('afterend', close);
  }

  function moveNote() {
    var note = document.querySelector('cart-note.cart__note, .cart__note');
    if (!note) return;

    var itemsSection = document.querySelector('#MainContent > [id$="__cart-items"]');
    if (!itemsSection) return;
    if (itemsSection.contains(note) && note.dataset.taMoved) return;

    var table = itemsSection.querySelector('table.cart-items, .cart-items');
    if (table && table.parentElement) {
      table.parentElement.insertBefore(note, table.nextSibling);
    } else {
      (itemsSection.querySelector('.cart__contents') || itemsSection).appendChild(note);
    }

    note.dataset.taMoved = '1';
    note.classList.add('ta-note');

    var label = note.querySelector('label');
    if (label) label.textContent = NOTE_LABEL;

    var field = note.querySelector('textarea');
    if (field) field.setAttribute('placeholder', NOTE_PLACEHOLDER);
  }

  function build() {
    if (!onCartPage()) return;
    document.documentElement.classList.add('ta-cart-open');
    buildHeader();
    moveNote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  /* Dawn re-renders both sections after every quantity change, which puts a
     fresh note back inside the footer. */
  document.addEventListener('click', function () {
    setTimeout(moveNote, 350);
  });
  setTimeout(build, 800);
})();
